<template>
  <div class="select" :style="{ background: +status === 0 ? 'rgb(248, 248, 248)' : '#fff' }">
    <!-- 正常状态 -->
    <div class="select-normal" v-if="+status === 0">
      <section class="select-normal-box">
        <div class="select-normal-box-header">
          <z-image
            fit="cover"
            class="select-normal-box-header-image"
            src="n_v2b2e534d0559d4124952d6f30c82b2638.png"
          />
          <span>申请赔付流程</span>
          <z-image
            fit="cover"
            class="select-normal-box-header-image"
            src="n_v2b2e534d0559d4124952d6f30c82b2638.png"
          />
        </div>
        <div class="select-normal-box-content">
          <Step
            title="欺诈举报"
            content="遇到交易欺诈，先进行欺诈举报"
            pic="n_v28df6d0c3a2a148ae85a9d7cb1d29fde8.png"
            iconName="n_v2bb0c81ad1b634d7e9d32a7e52cb813a8.png"
          />
          <Step
            title="审核成立"
            content="欺诈举报平台审核成立"
            pic="n_v2f20091e9f1de46a29ccb0f067a579a44.png"
            iconName="n_v2e1bdb75173c14bedabdf659732f372f6.png"
          />
          <Step
            title="申请赔付"
            content="符合条件的订单可申请赔付"
            pic="n_v275b16e78cc564447af05eae046eeaf56.png"
            iconName="n_v25dbd1859f160410ab33952f46ef91f9f.png"
          />
        </div>
      </section>

      <section class="select-normal-box">
        <div class="select-normal-box-header">
          <z-image
            fit="cover"
            class="select-normal-box-header-image"
            src="n_v2b2e534d0559d4124952d6f30c82b2638.png"
          />
          <span>申请赔付注意事项</span>
          <z-image
            fit="cover"
            class="select-normal-box-header-image"
            src="n_v2b2e534d0559d4124952d6f30c82b2638.png"
          />
        </div>
        <div class="select-normal-box-question">
          <div class="select-normal-box-question-icon">
            <z-icon name="n_v2fe1d9b1cfd124a688cd9654c0ea55a8d.png" size="16px" />
          </div>
          <span
            >仅可对近30天内且在保障领取有效期内，已完成的欺诈订单（须为实物交易）进行赔付申请</span
          >
        </div>
        <div class="select-normal-box-question">
          <div class="select-normal-box-question-icon">
            <z-icon name="n_v291297e54869944878f6017a446ab65b2.png" size="16px" />
          </div>
          <span
            >填写赔付说明前请先准确好相关材料：本人身份证件、派出所报案回执（损失超过3000元必须提供）</span
          >
        </div>
      </section>
    </div>

    <!-- 非正常状态 -->
    <div class="select-info" v-else>
      <z-image v-if="data.imgUrl" width="278" px2rem :src="data.imgUrl" />
      <z-loading v-if="!data.imgUrl" type="spinner" color="#ff5555" />
      <p class="select-info-title">
        <b>{{ data.title }}</b>
      </p>
      <p class="select-info-content">{{ data.content }}</p>
    </div>

    <!-- 下拉选择订单 -->
    <z-action-picker v-model="show" :show-btn="false" :show-close="true">
      <!-- <div class="action-content"> -->
      <z-tabs center swipeable :offset-top="0" @change="change">
        <z-tab title="我买到的">
          <select-pay identity="buyer" :active="active" :applySource="applySource" :toUid="toUid" />
        </z-tab>
        <z-tab title="我卖出的">
          <select-pay
            identity="seller"
            :active="active"
            :applySource="applySource"
            :toUid="toUid"
          />
        </z-tab>
      </z-tabs>
      <!-- </div> -->
    </z-action-picker>

    <!-- <div>测试专用</div>
    <div>【applySource】:{{applySource}}</div>
    <div>【toUid】:{{toUid}}</div>
    <div>【orderId】:{{orderId}}</div> -->

    <!-- 底部按钮 -->
    <z-button-group v-show="!!data.btnText || +status === 0">
      <z-button type="primary" @click="click(status, data.btnLink)">{{
        +status === 0 ? '选择订单请赔付' : data.btnText
      }}</z-button>
    </z-button-group>
    </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import {
  Button,
  ButtonGroup,
  Tabs,
  Tab,
  ActionPicker,
  Image,
  Icon,
  Loading
} from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'
import { queryParams } from '../../../lib/utils'
import { getPayMoneyStatus } from '../../../api/resourceApi'
import Step from './Step'
import selectPay from './select-pay'

const query = queryParams()

export default {
  name: 'SelectComp',
  data() {
    return {
      applySource: query.applySource || this.$route.query.applySource, //安全中心:securitycenter|举报记录详情页:report|领取成功页:receive|重新申请:reapply
      toUid: query.toUid || this.$route.query.toUid, //只有从举报记录详情页进来才有
      orderId: query.orderId || this.$route.query.orderId, //只有从重新领取详情页进来才有
      isLoading: false,
      pageNum: 1,
      active: 0,
      show: false,
      status: 1, //0:正常|1:j进行中|2:额度已用完|3:账户异常|4:三次未通过,
      data: {},
      certification: false,
      applyList: [],
      reportApplyList: []
    }
  },
  components: {
    zTabs: Tabs,
    zTab: Tab,
    zButtonGroup: ButtonGroup,
    zButton: Button,
    zActionPicker: ActionPicker,
    zImage: Image,
    zIcon: Icon,
    zLoading: Loading,
    selectPay,
    Step
  },
  methods: {
    async getStatus() {
      this.loading = true
      const res = await getPayMoneyStatus({ orderId: this.orderId })
      const { status, ...data } = res
      this.loading = false
      this.status = status
      this.data = data
    },
    change(index, title) {
      console.log('index', index)
      console.log('title', title)
      this.active = index
    },
    click(status, targetUrl) {
      if (+status === 0) {
        this.show = true
        return ''
      } else {
        this.jump(targetUrl)
      }
    },
    jump(targetUrl) {
      setTimeout(() => {
        native.skipToUrl({
          targetUrl
        })
      }, 300)
    }
  },
  mounted() {
    native.setTitle({
      title: '放心转'
    })
    const obj = {
      label: '赔付说明',
      url: 'https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyDescription',
      newPageTitle: '赔付说明',
      needLogin: 0,
      color: '#111111'
    }
    native.wrap('setRightBtn')(obj)
    this.getStatus()
    console.log('toUid', this.toUid)
    lego.send({
      pagetype: 'ZZUP_PAYMONEY',
      actiontype: 'SELECT_SHOW',
      backup: {
        applySource: this.applySource //安全中心:securitycenter|举报记录详情页:report|领取成功页:receive|重新申请:reapply
      }
    })
  },
  destroyed() {},
  beforeRouteEnter(_to, _from, next) {
    // const obj = {
    //   label: '赔付说明',
    //   url: 'https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyDescription',
    //   newPageTitle: '赔付说明',
    //   needLogin: 0,
    //   color: '#111111'
    // };
    next((_vm) => {
      // native.wrap('setRightBtn')(obj)
    })
  }
}
</script>

<style lang="less">
  @import 'index.less';
</style>
